import ExpansionPanels from 'www/modules/ExpansionPanels'

const expansionPanelElement = document.getElementById('common-rating')

if (expansionPanelElement) {
  new ExpansionPanels({
    target: expansionPanelElement,
  })
}
